/* eslint-disable react/prop-types */
import React, { createContext, useState } from 'react';

export const Context = createContext();

export default (props) => {
  const { value, children } = props;

  const [ showTranslationKeys, setShowTranslationKeys ] = useState(false);

  return (
    <Context.Provider
      value={{
        translations: value.translations,
        preview: value.isPreview,
        language: value.language,
        admin: value.admin,
        showTranslationKeys,
        setShowTranslationKeys
      }}
    >
      {children}
    </Context.Provider>
  );
};
